export default "__VITE_ASSET__BKrWV99L__"